const oldChildNavGoTo = theme.Slideshow.prototype.childNavGoTo;

theme.Slideshow.prototype.childNavGoTo = function(index) {

    const visibleLinks = [...this.childNavLinks].filter(link =>
        !link.closest('.product__thumb-item').classList.contains('hide')
    );

    this.childNavLinks.forEach(a => {
        a.blur();
        a.classList.remove('is-active');
    });

    const el = visibleLinks[index];

    if (!el) return;

    el.classList.add('is-active');

    if (!this.args.childNavScroller) return;

    if (this.args.childVertical) {
        this.args.childNavScroller.scrollTop = el.offsetTop - 100;
    } else {
        this.args.childNavScroller.scrollLeft = el.offsetLeft - 100;
    }
};


document.addEventListener('variant:change', function(e) {

    const product = theme.sections.instances.find(
        x => x.type === 'product'
    );

    if (!product) return;

    const colourWrap = product.container.querySelector(
        '.variant-input-wrap[data-handle="colour"], .variant-input-wrap[data-handle="color"]'
    );

    // Product has no colour option -> don't filter images
    if (!colourWrap) return;

    // Ignore changes to non-colour options (eg Size)
    if (e.detail.index !== colourWrap.dataset.index) {
        return;
    }

    const selectedColour = colourWrap
        .querySelector('input[data-variant-input]:checked')
        ?.value
        ?.trim()
        .toUpperCase();

    rebuildGallery(product, selectedColour);

});


function rebuildGallery(product, colour) {

    console.log('Rebuilding gallery', colour);

    product.cache.mainSlider.querySelectorAll('.product-main-slide').forEach((slide, i) => {

        const alt = slide.dataset.mediaAlt || slide.dataset.imageAlt || '';
        const show = imageMatchesColour(alt, colour);

        console.log(i, show, alt);

        slide.classList.toggle('variant-hidden', !show);

    });

    console.log(
        [...product.cache.mainSlider.querySelectorAll('.product-main-slide')]
            .map(s => ({
                hidden: s.classList.contains('variant-hidden'),
                class: s.className,
                alt: s.dataset.mediaAlt
            }))
    );

    let visibleIndex = 0;

    product.cache.thumbSlider
    .querySelectorAll('.product__thumb-item')
    .forEach((thumb, i) => {

        const slides = [
            ...product.cache.mainSlider.querySelectorAll('.product-main-slide')
        ];

        product.cache.thumbSlider
        .querySelectorAll('.product__thumb-item')
        .forEach(thumb => {

            const mediaId = thumb.querySelector('a').dataset.id;

            const slide = slides.find(
                s => s.dataset.mediaId === mediaId
            );

            if (!slide) {
                console.warn('No slide for media', mediaId);
                return;
            }

            const hidden = slide.classList.contains('variant-hidden');

            thumb.classList.toggle('hide', hidden);
        });
    });

        

    if (product.flickity) {
        console.log(
            'Visible slides',
            product.cache.mainSlider.querySelectorAll('.product-main-slide:not(.variant-hidden)').length
        );

        console.log(
            [...product.cache.mainSlider.querySelectorAll('.product-main-slide')]
                .map((s,i)=>({
                    i,
                    hidden:s.classList.contains('variant-hidden'),
                    alt:s.dataset.mediaAlt
                }))
        );
        product.flickity.destroy();
    }

    product.settings.currentSlideIndex = 0;

    product.flickity = new theme.Slideshow(product.cache.mainSlider, {
        dragThreshold: 25,
        adaptiveHeight: true,
        avoidReflow: true,
        initialIndex: 0,
        childNav: product.cache.thumbSlider,
        childNavScroller: product.cache.thumbScroller,
        childVertical: product.cache.thumbSlider.dataset.position === 'beside',
        pageDots: true,
        wrapAround: true,
        cellSelector: '.product-main-slide:not(.variant-hidden)',
        callbacks: {
            onInit: product.onSliderInit.bind(product),
            onChange: product.onSlideChange.bind(product)
        }
    });

    console.log(
        [...product.cache.thumbSlider.querySelectorAll('.product__thumb-item')]
            .map((t, i) => ({
                i,
                hidden: t.classList.contains('hide'),
                active: t.querySelector('a')?.classList.contains('is-active'),
                mediaId: t.querySelector('a')?.dataset.id,
                index: t.querySelector('a')?.dataset.index
            }))
    );

    console.log(
        "AFTER SLIDESHOW",
        [...product.cache.thumbSlider.querySelectorAll('.product__thumb-item')]
            .map(t => t.className)
    );


}

function imageMatchesColour(alt, colour) {

    const match = (alt || '').match(/COL=([^|]+)/i);

    // No COL tag? Show the image.
    if (!match) return true;

    const colours = match[1]
        .split(',')
        .map(c => c.trim().toUpperCase());

    return colours.includes(colour);

}